export const GET_ALL_PROTOCOLS = "GET_ALL_PROTOCOLS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_PROTOCOLS = "START_LOADING_PROTOCOLS";
export const STOP_LOADING_PROTOCOLS = "STOP_LOADING_PROTOCOLS";
export const ERROR_LOADING_PROTOCOLS = "ERROR_LOADING_PROTOCOLS";